import { useAuth } from "../auth";

/**
 * The sign-in screen, and the way out of a refused sign-in.
 *
 * The refusal is the part worth care. Firebase keeps a refused session in the
 * browser, so the screen came back saying the login had failed on every reload,
 * with nothing on it that could change the outcome — no sign-out, and no way to
 * pick a different Google account. Reported as "it always says the connection
 * failed", which is precisely what it did.
 *
 * So a refusal now names the address that was refused and offers the only two
 * things that can help: try another account, or ask to be added.
 */
export function SignInPage() {
  const { signIn, useAnotherAccount, signOutNow, status, error, deniedEmail } = useAuth();
  const busy = status === "authorizing";
  const denied = status === "denied";

  return (
    <div className="signin-wrap">
      <div className="signin">
        <div className="signin-mark">חב״ד</div>
        <h1>מערכת בית חב״ד הפארק</h1>
        <p>ניהול קהילה, אירועים ותרומות</p>

        {denied ? (
          <>
            <div className="notice error" style={{ textAlign: "start" }}>
              {deniedEmail ? (
                <>
                  <strong>נכנסתם עם {deniedEmail}</strong>
                  <br />
                  לחשבון הזה אין גישה למערכת. יש לכם חשבון אחר? התחברו איתו.
                </>
              ) : (
                (error ?? "לא הצלחנו לבדוק את ההרשאות שלכם. נסו שוב.")
              )}
            </div>

            <button className="google-btn" onClick={useAnotherAccount} disabled={busy}>
              <GoogleIcon />
              {busy ? "מתחברים…" : "התחברו עם חשבון אחר"}
            </button>

            {/* Leaving is its own action. Without it the only exit from a
                refused session is clearing the browser's site data. */}
            <button
              type="button"
              className="signin-secondary"
              onClick={signOutNow}
              disabled={busy}
            >
              יציאה
            </button>

            <p className="signin-foot">
              כדי לקבל גישה, צריך להוסיף את הכתובת הזו לרשימת המורשים במערכת.
            </p>
          </>
        ) : (
          <>
            <button className="google-btn" onClick={signIn} disabled={busy}>
              <GoogleIcon />
              {busy ? "מתחברים…" : "התחברות עם Google"}
            </button>

            {error && <div className="notice error">{error}</div>}
          </>
        )}
      </div>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
      <path
        fill="#4285F4"
        d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.7-1.57 2.68-3.88 2.68-6.62Z"
      />
      <path
        fill="#34A853"
        d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.8.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.33A9 9 0 0 0 9 18Z"
      />
      <path
        fill="#FBBC05"
        d="M3.97 10.72a5.4 5.4 0 0 1 0-3.44V4.95H.96a9 9 0 0 0 0 8.1l3.01-2.33Z"
      />
      <path
        fill="#EA4335"
        d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58C13.46.9 11.43 0 9 0A9 9 0 0 0 .96 4.95l3.01 2.33C4.68 5.16 6.66 3.58 9 3.58Z"
      />
    </svg>
  );
}
